import React from 'react';
import {
  BusinessAudience,
  BusinessAudienceLabels,
} from '../../../shared/account';
import {keys} from '../../../shared/util';
import {FilterSelect} from './FilterSelect';
import {FilterControlWithNegate} from './FilterControlWithNegate';

const audienceOptions = keys(BusinessAudienceLabels).map((value) => ({
  value,
  label: BusinessAudienceLabels[value],
}));

export const AudienceFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: BusinessAudience[];
  negate?: boolean;
  onChange: (value: BusinessAudience[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  const selectedAudienceOptions = value.map((v) => ({
    value: v,
    label: BusinessAudienceLabels[v],
  }));

  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          options={audienceOptions}
          isMulti
          onChange={(values) => {
            onValueChange(values.map((v) => v.value) as BusinessAudience[]);
          }}
          value={selectedAudienceOptions}
        />
      )}
    </FilterControlWithNegate>
  );
};
